import { createSelector } from 'reselect';

export const getResourcesState = (state) => state.resources || [];

export const getResources = createSelector(
    getResourcesState,
    (resources) => resources.resources,
);
